var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box display-flex flex-wrap flex-column",attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"top background",style:({ 'background-image': `url(${_vm.backgroundUrl})` })}),_c('div',{staticClass:"bottom flex-1 flex-centerize"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }